export const deepClone = <T>(obj: any) => JSON.parse(JSON.stringify(obj)) as T
